import React from 'react';
import PropTypes from 'prop-types';
import styles from './PreviewShell.module.scss';

/**
 * Shared wrapper around every layout-mode preview body.
 *
 * Responsibilities:
 *   - Fixed-size flex column that never introduces an inner scrollbar (which
 *     would interfere with React Grid Layout's pointer hit-testing during
 *     drag).
 *   - Pauses every `.skeleton` / `.skeleton-text` shimmer animation inside
 *     the subtree (see the SCSS module for the full rationale). Previews
 *     are static cosmetic placeholders — no loading animation required.
 *   - `contain: layout paint` isolates the subtree on its own compositor
 *     layer so drag transforms don't trigger re-rasterisation.
 *
 * Memoized so its structural identity is stable across parent renders.
 */
const PreviewShell = React.memo(({ children }) => (
	<div className={styles.shell}>{children}</div>
));

PreviewShell.displayName = 'LayoutPreviewShell';
PreviewShell.propTypes = { children: PropTypes.node };

export default PreviewShell;
